import { render, staticRenderFns } from "./OutOfCalibrationDateModal.vue?vue&type=template&id=224b1e71&scoped=true"
import script from "./OutOfCalibrationDateModal.vue?vue&type=script&lang=js"
export * from "./OutOfCalibrationDateModal.vue?vue&type=script&lang=js"
import style0 from "./OutOfCalibrationDateModal.vue?vue&type=style&index=0&id=224b1e71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224b1e71",
  null
  
)

export default component.exports